import React from 'react';
import './infrastructure.css';

function Infrastructure() {
  return (
    <div className="infra-container">
      <div className="infra-background">
        <h1>Our Infrastructure</h1>
        <p>
          At <strong>Neelaverse Technologies</strong>, our infrastructure is tailored to support development and creative innovation. As a dynamic startup, we believe in keeping things smart, scalable, and effective.
        </p>

        <div className="infra-section">
          <h2>🚀 Development Environment</h2>
          <ul>
            <li>Modern laptops & high-speed internet for all developers</li>
            <li>Cloud-based repositories (GitHub, GitLab)</li>
            <li>VSCode, IntelliJ, and custom tools for rapid prototyping</li>
          </ul>
        </div>

        <div className="infra-section">
          <h2>🌐 Collaborative Tools</h2>
          <ul>
            <li>Slack & Microsoft Teams for seamless communication</li>
            <li>Jira for agile sprint planning and task tracking</li>
            <li>Zoom & Meet for team standups and client calls</li>
          </ul>
        </div>

        <div className="infra-section">
          <h2>🔒 Security & Reliability</h2>
          <ul>
            <li>VPN & secure cloud storage for project files</li>
            <li>Two-factor authentication on all critical systems</li>
            <li>Regular backups and encrypted communication</li>
          </ul>
        </div>

        <div className="infra-section">
          <h2>🏠 Workspace</h2>
          <ul>
            <li>Open office layout to encourage collaboration</li>
            <li>Breakout zones for brainstorming and ideation</li>
            <li>Fully remote/hybrid-friendly infrastructure</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Infrastructure;
